import { render, staticRenderFns } from "./LayoutRow.vue?vue&type=template&id=24e1018e&scoped=true"
import script from "./LayoutRow.vue?vue&type=script&lang=ts"
export * from "./LayoutRow.vue?vue&type=script&lang=ts"
import style0 from "./LayoutRow.vue?vue&type=style&index=0&id=24e1018e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1018e",
  null
  
)

export default component.exports